module.exports = __webpack_public_path__ + "static/media/FC_on.b55ac836.svg";